import React from 'react';
import { Route } from '@reverbdotcom/commons/src/route_settings';
import { RailsViewActions } from '../components/discovery/rails_view_store';
import isNode from '@reverbdotcom/commons/src/is-node';
import RailsView from '../components/discovery/feed/rails_view';
import { MParticlePageName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

const WatchedProductsRoute = (
  <Route
    key="watched_products"
    path="watched_products"
    component={RailsView}
    props={{
      pageViewEvent: { pageName: MParticlePageName.WatchList },
    }}
    onChange={(_, nextState) => {
      RailsViewActions.fetchHTML('/watched_products', nextState.location.query);
    }}
    onEnter={(nextState) => {
      if (isNode) { return; }

      RailsViewActions.fetchHTML('/watched_products', nextState.location.query);
    }}
    onLeave={() => {
      RailsViewActions.clearHTML();
    }}
  />
);

export default WatchedProductsRoute;
